import { useEffect, useState } from "react";

/**
 * 檢測是否為觸控裝置
 * @returns {boolean} 是否為觸控裝
 */
const useIsTouchDevice = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const hasTouchScreen =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      // @ts-ignore - 某些瀏覽器可能不支援
      navigator.msMaxTouchPoints > 0;

    setIsTouchDevice(hasTouchScreen);
  }, []);

  return isTouchDevice;
};

export default useIsTouchDevice;
